import { render, staticRenderFns } from "./EventDibs.vue?vue&type=template&id=b2ddee12&"
import script from "./EventDibs.vue?vue&type=script&lang=js&"
export * from "./EventDibs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports